import { api } from './api';

export interface FlowSummary {
  id: string;
  nome: string;
  descricao: string;
  estagios: number;
  modelos: string[];
}

export interface FlowStage {
  id: string;
  nome: string;
  ordem: number;
  model: string;
  role_system: string;
  default_system: string;
  is_overridden: boolean;
  user_template: string;
  saida: string;
  nota?: string | null;
}

export interface RunInput {
  kind: 'text' | 'select';
  label: string;
  placeholder?: string;
  options?: string[];
}

export interface FlowDetail {
  id: string;
  nome: string;
  descricao: string;
  run_input: RunInput;
  stages: FlowStage[];
}

export interface RunStageOut {
  id: string;
  ok: boolean;
  output: string | null;
  error: string | null;
}

export interface RunResult {
  query: string;
  summary: string;
  meta?: Record<string, unknown>;
  stages: RunStageOut[];
}

export const engineeringService = {
  listFlows: (): Promise<FlowSummary[]> =>
    api.get<{ flows: FlowSummary[] }>('/engineering/flows').then((r) => r.flows),
  getFlow: (flowId: string): Promise<FlowDetail> =>
    api.get<FlowDetail>(`/engineering/flows/${flowId}`),
  savePrompt: (
    flowId: string,
    stageId: string,
    system: string,
  ): Promise<{ system: string; is_overridden: boolean }> =>
    api.put(`/engineering/flows/${flowId}/stages/${stageId}`, { system }),
  run: (flowId: string, query: string, upto?: string): Promise<RunResult> =>
    api.post<RunResult>(`/engineering/flows/${flowId}/run`, { query, upto: upto ?? null }),
};
